import * as React from 'react';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import { useState } from 'react';
import TableContainer from '@mui/material/TableContainer';
import { Alert, Button, FormControlLabel, Stack, Switch, Tooltip } from '@mui/material';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import TextField from '@mui/material/TextField';
import Autocomplete from '@mui/material/Autocomplete';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router';
import AxiosAll from 'src/services/axiosAll';
import { RHFTextField } from '../hook-form';
import Iconify from '../Iconify';
import MobilePicker from '../Timepicker';

// import { FormControlLabel, FormGroup, Switch } from '@mui/material';

function createData(name: string, calories: number, fat: number, carbs: number, protein: number) {
  return { name, calories, fat, carbs, protein };
}

export default function EditInputTable({ userData, values, path, MomMId, updateMemberRow }) {
  const { userDetails } = useSelector((state) => state.loginReducer);
  const { token, user } = userDetails;
  const [message, setMessage] = useState('');
  const [deleteminute, setDeleteMinute] = useState([]);
  const navigate = useNavigate();
  const [meeting, setMeetingRows] = React.useState([
    {
      LocalId: 1,
      subject: '',
      description: '',
      action_point: '',
      due_time: null,
      due_date: null,
      assigned_user: '',
      create_task: false,
    },
    {
      LocalId: 2,
      subject: '',
      description: '',
      action_point: '',
      due_time: null,
      due_date: null,
      assigned_user: '',
      create_task: false,
    },
    {
      LocalId: 3,
      subject: '',
      description: '',
      action_point: '',
      due_time: null,
      due_date: null,
      assigned_user: '',
      create_task: false,
    },
    {
      LocalId: 4,
      subject: '',
      description: '',
      action_point: '',
      due_time: null,
      due_date: null,
      assigned_user: '',
      create_task: false,
    },
    {
      LocalId: 5,
      subject: '',
      description: '',
      action_point: '',
      due_time: null,
      due_date: null,
      assigned_user: '',
      create_task: false,
    },
  ]);

  React.useEffect(() => {
    const storedData = JSON.parse(localStorage.getItem('meetingrows1'));
    if (storedData) {
      setMeetingRows(storedData);
    } else if (MomMId && updateMemberRow?.length > 0) {
      setMeetingRows(updateMemberRow);
      localStorage.setItem('meetingrows1', JSON.stringify(updateMemberRow));
    } else {
      setMeetingRows(meeting);
    }
  }, [values]);
  // console.log("check aray or not ", Array.isArray(userData)); // Output should be true if userData is an array

  const addNewRow = () => {
    const newId = meeting.length + 1;
    const newRow = { LocalId: newId, title: '', description: '', assigned_user: '', create_task: false };
    setMeetingRows([...meeting, newRow]);
    localStorage.setItem('meetingrows1', JSON.stringify([...meeting, newRow]));
  };

  const removeObjectById = (id, mom_id) => {
    const updatedMeeting = meeting.filter((row) => row.LocalId !== id);
    setMeetingRows(updatedMeeting);

    if (mom_id !== undefined) {
      deleteminute.push(id);
      setDeleteMinute(deleteminute);
    }
    localStorage.setItem('meetingrows1', JSON.stringify(updatedMeeting));
  };
  const handleChange = (index, field, value) => {
    const updatedData = [...meeting];
    // Update the specific field in the copied array
    updatedData[index] = {
      ...updatedData[index],
      [field]: value,
      isChange: true, // Adding the new key
    };

    // Update the state with the new array
    setMeetingRows(updatedData);
    localStorage.setItem('meetingrows1', JSON.stringify(updatedData));
    setMessage('');
  };
  const assingValue = (id) => {
    if (id !== 0) {
      const result = userData?.find((e) => e?.id === id);
      return result;
    }
    // Handle the case when id is 0 or undefined
    return null;
  };
  const UpdateMomFeature = async () => {
    const changedMeetings = meeting?.filter((meeting) => meeting.isChange === true);
    const idsUpdateArray = changedMeetings?.map((meeting) => (meeting.mom_id ? meeting?.id : ''));
    // console.log("idsUpdateArray", idsUpdateArray)
    const filteredData = meeting.filter(
      (item) => item.subject !== '' && item.description !== '' && item.action_point !== ''
    );
    if (filteredData?.length && values?.project && values?.startDate && values?.title) {
      const data = {
        project_id: values?.project,
        date: values?.startDate,
        title: values?.title,
        delete_details: deleteminute,
        update_details: idsUpdateArray,
        details: filteredData,
      };
      const res = await AxiosAll('post', `/v2/minutes-of-meeting/${MomMId}`, data, token);
      if (res?.status === 200) {
        const newData = res?.data;
        localStorage.removeItem('meetingrows1');
        localStorage.removeItem('momPojectDetail1');
        if (user?.role_id === 3 || user?.role_id === 4) {
          navigate('/minutes-of-meeting');
        } else {
          navigate('/tasks/project-wise');
        }
        // setProjectData(newData);
      }
    } else {
      setMessage(filteredData?.length === 0 ? 'Please add minutes of meeting' : null);
    }
  };
  // console.log("meeting", meeting)
  return (
    <TableContainer component={Paper} sx={{ mt: 4 }}>
      {message && <Alert severity="error">{message}</Alert>}
      {userData && userData?.length > 0 ? (
        <>
          {' '}
          <Table sx={{ minWidth: 650 }} aria-label="simple table" className="addmom_table">
            <TableHead>
              <TableRow>
                <TableCell align="center">Subject</TableCell>
                <TableCell align="center">Description</TableCell>
                <TableCell align="center">Action Point</TableCell>
                <TableCell align="center">Assign User</TableCell>
                <TableCell align="center">Create Task</TableCell>
                <TableCell align="center">Due Date</TableCell>
                <TableCell align="center">Due Time</TableCell>
                <TableCell align="center">Action</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {meeting?.map((row, index) => (
                <>
                  <TableRow
                    key={row.id}
                    sx={{ verticalAlign: 'top', cursor: row?.id && row?.create_task ? 'pointer' : '' }}
                    // onClick={() => row?.id && row?.create_task && navigate(`/tasks/edit/${row?.task_id}`)}
                  >
                    <TableCell scope="row">
                      <RHFTextField
                        onChange={(e) => handleChange(index, 'subject', e.target.value)}
                        value={row?.subject}
                        name={`meetingrows1[${index}].subject`}
                        fullWidth
                        variant="standard"
                        placeholder="Please describe subject.."
                      />
                    </TableCell>
                    <TableCell align="center">
                      <RHFTextField
                        onChange={(e) => handleChange(index, 'description', e.target.value)}
                        value={row?.description}
                        name={`meetingrows1[${index}].description`}
                        placeholder="Write Something Description..."
                        multiline
                        rows={3}
                        variant="standard"
                      />
                    </TableCell>
                    <TableCell scope="row">
                      <RHFTextField
                        onChange={(e) => handleChange(index, 'action_point', e.target.value)}
                        value={row?.action_point}
                        name={`meetingrows1[${index}].action_point`}
                        fullWidth
                        variant="standard"
                        placeholder="Action point  .."
                      />
                    </TableCell>
                    <TableCell sx={{ display: 'flex', justifyContent: 'center' }} className="auto_select_box">
                      <Autocomplete
                        disablePortal
                        id="combo-box-demo"
                        name={`meetingrows1[${index}].assigned_user`}
                        onChange={(e, value) => handleChange(index, 'assigned_user', value?.id)}
                        options={userData}
                        value={assingValue(row?.assigned_user ? row?.assigned_user : 0)}
                        sx={{ width: 200 }}
                        renderInput={(params) => <TextField {...params} variant="standard" />}
                      />
                    </TableCell>
                    <TableCell align="center">
                      {/* Add your create_task input field here */}
                      <FormControlLabel
                        control={
                          <Switch
                            type="checkbox"
                            disabled={row.mom_id}
                            checked={row.create_task}
                            name={`meetingrows1[${index}].create_task`}
                            onChange={(e) => handleChange(index, 'create_task', e.target.checked)}
                          />
                        }
                      />
                    </TableCell>
                    <TableCell align="center">
                      <RHFTextField
                        disabled={!row.create_task}
                        min={values?.startDate}
                        value={row?.due_date}
                        name={`meetingrows1[${index}].due_date`}
                        type="date"
                        onChange={(e) => handleChange(index, 'due_date', e.target.value)}
                      />
                    </TableCell>
                    <TableCell align="center">
                      <MobilePicker
                        disabled={!row.create_task}
                        name={`meetingrows1[${index}].due_time`}
                        time={row?.due_time}
                        handleTime={(e) => handleChange(index, 'due_time', e)}
                      />
                    </TableCell>

                    <TableCell align="center">
                      {meeting?.length > 1 && (
                        <Iconify
                          onClick={() => removeObjectById(row.id ? row?.id : row?.LocalId, row?.mom_id)}
                          icon={'fluent:delete-24-filled'}
                          width={28}
                          height={28}
                          style={{ cursor: 'pointer' }}
                        />
                      )}
                      {row?.mom_id && row?.task_id && (
                        <Iconify
                          onClick={() => row?.create_task && navigate(`/tasks/edit/${row?.task_id}`)}
                          icon={'carbon:view-filled'}
                          width={28}
                          height={28}
                          style={{ cursor: 'pointer' }}
                        />
                      )}
                    </TableCell>
                  </TableRow>
                </>
              ))}
            </TableBody>
          </Table>
          <Stack spacing={3} direction="row" justifyContent="flex-end" sx={{ mt: 2 }}>
            <Button variant="contained" onClick={addNewRow}>
              Add Row
            </Button>
            <Button variant="contained" type="submit" onClick={UpdateMomFeature}>
              submit
            </Button>
          </Stack>{' '}
        </>
      ) : null}
    </TableContainer>
  );
}
